import React from "react"
import { globalHistory } from "@reach/router"
import styled from "styled-components"
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share"
import { StyledHeading } from "../common"

const StyledBlogShare = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-end;

  h6 {
    font-size: 14px;
  }

  > article {
    margin-left: 1rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 0.5rem;
  }
`

export const BlogShare = () => {
  const { href } = globalHistory?.location
  return (
    <StyledBlogShare>
      <StyledHeading size="h7" color="#005d73" as="h6">
        Share Article:
      </StyledHeading>
      <article>
        <FacebookShareButton url={href}>
          <FacebookIcon
            round
            bgStyle={{ fill: "#005d73" }}
            iconFillColor="#fff"
            size={40}
          />
        </FacebookShareButton>
        <TwitterShareButton url={href}>
          <TwitterIcon
            round
            bgStyle={{ fill: "#005d73" }}
            iconFillColor="#fff"
            size={40}
          />
        </TwitterShareButton>
        <LinkedinShareButton url={href}>
          <LinkedinIcon
            round
            bgStyle={{ fill: "#005d73" }}
            iconFillColor="#fff"
            size={40}
          />
        </LinkedinShareButton>
        <EmailShareButton url={href}>
          <EmailIcon
            round
            bgStyle={{ fill: "#005d73" }}
            iconFillColor="#fff"
            size={40}
          />
        </EmailShareButton>
      </article>
    </StyledBlogShare>
  )
}
